import { render } from "./ReadingGoalModal.vue?vue&type=template&id=5f904d82&scoped=true"
import script from "./ReadingGoalModal.vue?vue&type=script&lang=js"
export * from "./ReadingGoalModal.vue?vue&type=script&lang=js"

import "./ReadingGoalModal.vue?vue&type=style&index=0&id=5f904d82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f904d82"]])

export default __exports__